import { ERP_ROUTE, USERS_ROUTE } from "model/constants/routes";

export const getSubCategoryPath = (
  path: string,
  categoryId: string,
  index = 0,
) => {
  switch (true) {
    case path === USERS_ROUTE || path === ERP_ROUTE:
      return `${path}/${categoryId}`;
    case index !== 0:
      return `${path}/${categoryId.toLowerCase().replace(/ /g, "_")}`;
    default:
      return path;
  }
};
